import type { FaireProductEntity } from "../../entity_types/product";

export const p_gcns9zt79c: FaireProductEntity = {
  token: "p_gcns9zt79c",
  type: "product",
  name: "S925 Sterling Silver Moissanite Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Gioiellin - S925 Silver Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/020cd69e4ca5c9cea99363b6e60c0e75b39c0903fc9643e03cfae22016f48696.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d8b32fb34eb7366d560a7a3d1889fbaa52d2e6e48b22b7b8affe7b46357f9afc.jpeg",
    "https://cdn.faire.com/fastly/1be0fd4b74c5085bb6dc448ddb92998431c1a8500ebb335e2314b3af57a6aa3a.jpeg",
    "https://cdn.faire.com/fastly/d3afa6a66423b09203c8b0fbde4df0655f9ddd0c03a055cc250c03ff129b2a2a.jpeg",
    "https://cdn.faire.com/fastly/00a131ce8a3c07e695dd7450c58944585fcf0695fee9ec93109016b9cd19a7f6.jpeg",
  ],
  priceDollars: 18.01,
  description:
    '"-ID: GIO-MD-RI2401\n-Material: S925 Sterling Silver White Gold Plated\n-Stone(s): Cubic Zirconia\n-Size: 5, 6, 7, 8, 9 (Standard US Size)\n-Weight(s): 0.74g\n-Quality: Excellent\n-Lead Free, -Nickel Free"',
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:10.351Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
